import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0aed4ab8")

_pushScopeId("data-v-0aed4ab8")
const _hoisted_1 = {
  novalidate: "",
  id: "agencyDetailsForm"
}
const _hoisted_2 = {
  class: "accordion",
  id: "accordionAgency"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  class: "default-card-header collapsed",
  id: "headingPersonalDetails",
  "data-toggle": "collapse",
  "data-target": "#agencyPersonalDetails"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "agencyPersonalDetails"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_8 = {
  id: "agencyPersonalDetails",
  class: "collapse",
  "aria-labelledby": "headingPersonalDetails",
  "data-parent": "#accordionAgency"
}
const _hoisted_9 = { class: "card-body default-card-body" }
const _hoisted_10 = { class: "several-section" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "default-title" }
const _hoisted_14 = {
  key: 0,
  class: "default-text"
}
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "default-text"
}
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "default-title" }
const _hoisted_20 = {
  key: 0,
  class: "default-text"
}
const _hoisted_21 = {
  key: 1,
  class: "default-text"
}
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "default-title" }
const _hoisted_24 = {
  key: 0,
  class: "default-text"
}
const _hoisted_25 = {
  key: 1,
  class: "default-text"
}
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "default-title" }
const _hoisted_28 = {
  key: 0,
  class: "default-text"
}
const _hoisted_29 = {
  key: 1,
  class: "default-text"
}
const _hoisted_30 = { class: "" }
const _hoisted_31 = { class: "default-title" }
const _hoisted_32 = {
  key: 0,
  class: "default-text"
}
const _hoisted_33 = {
  key: 1,
  class: "default-text"
}
const _hoisted_34 = {
  key: 0,
  class: "card"
}
const _hoisted_35 = {
  class: "default-card-header collapsed",
  id: "headingUsers",
  "data-toggle": "collapse",
  "data-target": "#agencyUsers"
}
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "agencyUsers"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_39 = {
  id: "agencyUsers",
  class: "collapse",
  "aria-labelledby": "headingUsers",
  "data-parent": "#accordionAgency"
}
const _hoisted_40 = { class: "card-body default-card-body" }
const _hoisted_41 = { class: "several-section" }
const _hoisted_42 = {
  key: 1,
  class: "card"
}
const _hoisted_43 = {
  class: "default-card-header collapsed",
  id: "headingGeneral",
  "data-toggle": "collapse",
  "data-target": "#agencyGeneral"
}
const _hoisted_44 = { class: "mb-0" }
const _hoisted_45 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "agencyGeneral"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_47 = {
  id: "agencyGeneral",
  class: "collapse",
  "aria-labelledby": "headingGeneral",
  "data-parent": "#accordionAgency"
}
const _hoisted_48 = { class: "card-body default-card-body" }
const _hoisted_49 = { class: "several-section" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "default-title" }
const _hoisted_53 = { class: "default-text m-0" }
const _hoisted_54 = { class: "col-md-6 d-flex align-items-center toggler-wrapper" }
const _hoisted_55 = { class: "mx-2 toggler" }
const _hoisted_56 = {
  key: 1,
  class: "default-text agency-status desktop"
}
const _hoisted_57 = {
  key: 0,
  class: "status-green"
}
const _hoisted_58 = {
  key: 1,
  class: "status-red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AgencyUsers = _resolveComponent("AgencyUsers")

  return (_openBlock(), _createBlock("form", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h5", _hoisted_5, [
            _createVNode("button", _hoisted_6, _toDisplayString(_ctx.$t('agencies.agency.title')), 1)
          ]),
          _hoisted_7
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('agencies.name')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkInputLength('name'))),
                              required: "",
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.agency.name = $event))
                            }, null, 544)), [
                              [_vModelText, _ctx.agency.name]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(_ctx.agency.name), 1))
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('agencies.personal.description')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_20, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("textarea", {
                              key: 0,
                              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkInputLength('description'))),
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.agency.description = $event))
                            }, null, 544)), [
                              [_vModelText, _ctx.agency.description]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_21, _toDisplayString(_ctx.agency.description), 1))
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('agencies.personal.mobile')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isTelephone($event))),
                              onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.additionalValidation && _ctx.additionalValidation(...args))),
                              maxlength: "16",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.agency.mobile = $event))
                            }, null, 544)), [
                              [_vModelText, _ctx.agency.mobile]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(_ctx.agency.mobile), 1))
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('agencies.personal.email')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "email",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.agency.email = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.agency.email]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_29, _toDisplayString(_ctx.agency.email), 1))
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('agencies.personal.website')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_32, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "url",
                            class: "bookit-input form-control",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.agency.website = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.agency.website]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_33, [
                      _createVNode("a", {
                        href: _ctx.validateWebsite,
                        class: "text-link",
                        target: "_blank"
                      }, _toDisplayString(_ctx.agency.website), 9, ["href"])
                    ]))
              ])
            ])
          ])
        ])
      ]),
      (_ctx.agency.id)
        ? (_openBlock(), _createBlock("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("h5", _hoisted_36, [
                _createVNode("button", _hoisted_37, _toDisplayString(_ctx.$t('agencies.users.title')), 1)
              ]),
              _hoisted_38
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _createVNode(_component_AgencyUsers, {
                    items: _ctx.agency.users,
                    agencyId: _ctx.agency.id
                  }, null, 8, ["items", "agencyId"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.agency.id)
        ? (_openBlock(), _createBlock("div", _hoisted_42, [
            _createVNode("div", _hoisted_43, [
              _createVNode("h5", _hoisted_44, [
                _createVNode("button", _hoisted_45, _toDisplayString(_ctx.$t('agencies.general')), 1)
              ]),
              _hoisted_46
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _createVNode("div", _hoisted_51, [
                      _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('agencies.dateOfRegistration')) + ":", 1),
                      _createVNode("div", _hoisted_53, _toDisplayString(_ctx.formatLocalDateTime(_ctx.agency.createDate)), 1)
                    ]),
                    _createVNode("div", _hoisted_54, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("div", {
                              class: ["default-title active-label", _ctx.agency.active ? 'green-color' : '']
                            }, _toDisplayString(_ctx.$t('label.active')), 3),
                            _createVNode("div", _hoisted_55, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                class: "toggle",
                                checked: _ctx.agency.active,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.agency.active = $event))
                              }, null, 8, ["checked"]), [
                                [_vModelCheckbox, _ctx.agency.active]
                              ])
                            ])
                          ], 64))
                        : (_openBlock(), _createBlock("div", _hoisted_56, [
                            (_ctx.agency.active)
                              ? (_openBlock(), _createBlock("span", _hoisted_57, "ACTIVE"))
                              : (_openBlock(), _createBlock("span", _hoisted_58, "NOT ACTIVE"))
                          ]))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})